import { render, staticRenderFns } from "./sidi-abdellah-algeria-hospital.vue?vue&type=template&id=6521c57c&"
import script from "./sidi-abdellah-algeria-hospital.vue?vue&type=script&lang=js&"
export * from "./sidi-abdellah-algeria-hospital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports